import { Anchor, Breadcrumbs, Grid, Text } from '@mantine/core';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import ErrorMessage from '../../../components/ErrorMessage';
import Metadata from '../../../components/Metadata';
import DetailedStatistics from '../../../components/Stats/DetailedStatistics';
import { Page } from '../../../constants/pageTitles';
import useFetch from '../../../helpers/useFetch';

const BannersStatisticsPage = ({ type = 'banners' }) => {
  const page = `${Page[type]}`;
  const fetch = useFetch();
  const [banner, setBanner] = useState();
  const [error, setError] = useState();
  const { accountId, domainId, id } = useParams();

  useEffect(() => {
    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/banners/${id}`)
      .then(({ banner }) => setBanner(banner))
      .catch(setError);
  }, [accountId, domainId, id, fetch]);

  return (
    <>
      <Metadata title={`${page} | ${banner?.name || 'Unnamed banner'}`} />
      <Breadcrumbs mb="md">
        <Anchor href={`#/accounts/${accountId}/domains/${domainId}/analytics`}>Home</Anchor>
        <Anchor href={`#/accounts/${accountId}/domains/${domainId}/banners`}>Banners</Anchor>
        <Text>{banner?.name || 'Unnamed banner'}</Text>
      </Breadcrumbs>
      <Grid>
        <Grid.Col span={12}>
          {error ? (
            <ErrorMessage message={error.message} />
          ) : (
            <DetailedStatistics name={banner?.name} scope="banners" id={id} />
          )}
        </Grid.Col>
      </Grid>
    </>
  );
};

export default BannersStatisticsPage;
